export function requestPatEligibility(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_REQUEST',
        vin,
        assignmentInstanceId
    }
}

export function retryPatEligibility(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_RETRY',
        vin,
        assignmentInstanceId
    }
}

export function receivePatEligibilitySuccess(vin, assignmentInstanceId, result) {
    return {
        type: 'PAT_ELIGIBILITY_SUCCESS',
        vin,
        assignmentInstanceId,
        result
    }
}

export function receivePatEligibilityError(vin, assignmentInstanceId, errorMessage) {
    return {
        type: 'PAT_ELIGIBILITY_ERROR',
        vin,
        assignmentInstanceId,
        errorMessage
    }
}

export function discardPatEligibility(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_DISCARD',
        vin,
        assignmentInstanceId
    }
}

export function selectPatSaleType(vin, assignmentInstanceId, saleType) {
    return {
        type: 'PAT_ELIGIBILITY_SELECT_SALE_TYPE',
        vin,
        assignmentInstanceId,
        saleType
    }
}

export function revertPatSaleType(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_REVERT',
        vin,
        assignmentInstanceId
    }
}

export function undoPatSaleType(vin, assignmentInstanceId) {
    return {
        type: 'PAT_ELIGIBILITY_UNDO',
        vin,
        assignmentInstanceId
    }
}

// Result of the lane-level pre-check on "GO" (getLaneSaleTypesEligibility) - overrideEligible false
// means PAT has nothing to offer for this location+lane at all, so the rest of this search session
// should behave as if the PAT toggle were off (no per-vehicle PAT calls, no Sale Type UI).
export function setLaneOverrideEligible(overrideEligible) {
    return {
        type: 'PAT_LANE_OVERRIDE_ELIGIBLE_SET',
        overrideEligible
    }
}

// Reset to the default (true - "assume eligible until the pre-check says otherwise") at the start of
// each new "GO" search, so a prior search's lane-level result never leaks into a new one.
export function resetLaneOverrideEligible() {
    return {
        type: 'PAT_LANE_OVERRIDE_ELIGIBLE_RESET'
    }
}
